"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _lodash = /*#__PURE__*/ _interop_require_default(require("lodash"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var getTargetSegments = function(offer) {
    return (0, _lodash.default)(offer).chain().get('targetsSegments').map('identifier.current').compact().value();
};
var _default = getTargetSegments;
